module.exports = __webpack_public_path__ + "static/media/instagram-logo.514db983.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/instagram-logo.png
// module id = 1821
// module chunks = 0